<section class="tw-bg-white tw-pt-2">
  <h2 class="tw-font-bold tw-text-600 tw-text-gray-800 tw-p-4"
      i18n="@@hairTransformation"
      [class]="acqRebranding2025() ? 'tw-font-lexend' : 'tw-font-body'">
    Look at our customer's real transformation stories
  </h2>
  @if (isFace()) {
    @for (src of faceImages(); track $index) {
      <div>
        <img id="faceDiv"
             alt="testimonials"
             class="tw-h-full tw-w-full"
             [src]="src" />
      </div>
    }
  } @else if (isHair()) {
    <div>
      <img id="hairDiv"
           alt="testimonials"
           class="tw-h-full tw-w-full"
           [src]="hairImageUrl()" />
    </div>
  }
</section>
